export default "__VITE_ASSET__Cqu850ns__"